module.exports = __webpack_public_path__ + "img/icon_toolkit.186c46d6.svg";